import { render, staticRenderFns } from "./tyoskentelyjaksot-yek-bar-chart.vue?vue&type=template&id=34bc482f&"
import script from "./tyoskentelyjaksot-yek-bar-chart.vue?vue&type=script&lang=ts&"
export * from "./tyoskentelyjaksot-yek-bar-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports